import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
const overlapMap = {
    xxs: pxToRem(-8),
    xs: pxToRem(-10),
    sm: pxToRem(-12),
    md: pxToRem(-14),
    lg: pxToRem(-18),
    xl: pxToRem(-20),
    '2xl': pxToRem(-24),
};
export const AvatarGroupContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;

  & > *:not(:first-child) {
    margin-left: ${({ $size = 'lg' }) => overlapMap[$size]};
    border-radius: 50%;
  }
`;
